export default __webpack_public_path__ + "2167ef80234fc8051ba97cb15515aa08.png";